(() => {
  // node_modules/ftdomdelegate/main.js
  function Delegate(root) {
    this.listenerMap = [{}, {}];
    if (root) {
      this.root(root);
    }
    this.handle = Delegate.prototype.handle.bind(this);
    this._removedListeners = [];
  }
  Delegate.prototype.root = function (root) {
    const listenerMap = this.listenerMap;
    let eventType;
    if (this.rootElement) {
      for (eventType in listenerMap[1]) {
        if (listenerMap[1].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, true);
        }
      }
      for (eventType in listenerMap[0]) {
        if (listenerMap[0].hasOwnProperty(eventType)) {
          this.rootElement.removeEventListener(eventType, this.handle, false);
        }
      }
    }
    if (!root || !root.addEventListener) {
      if (this.rootElement) {
        delete this.rootElement;
      }
      return this;
    }
    this.rootElement = root;
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.addEventListener(eventType, this.handle, false);
      }
    }
    return this;
  };
  Delegate.prototype.captureForType = function (eventType) {
    return ['blur', 'error', 'focus', 'load', 'resize', 'scroll'].indexOf(eventType) !== -1;
  };
  Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
    let root;
    let listenerMap;
    let matcher;
    let matcherParam;
    if (!eventType) {
      throw new TypeError('Invalid event type: ' + eventType);
    }
    if (typeof selector === 'function') {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      useCapture = this.captureForType(eventType);
    }
    if (typeof handler !== 'function') {
      throw new TypeError('Handler must be a type of Function');
    }
    root = this.rootElement;
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!listenerMap[eventType]) {
      if (root) {
        root.addEventListener(eventType, this.handle, useCapture);
      }
      listenerMap[eventType] = [];
    }
    if (!selector) {
      matcherParam = null;
      matcher = matchesRoot.bind(this);
    } else if (/^[a-z]+$/i.test(selector)) {
      matcherParam = selector;
      matcher = matchesTag;
    } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
      matcherParam = selector.slice(1);
      matcher = matchesId;
    } else {
      matcherParam = selector;
      matcher = Element.prototype.matches;
    }
    listenerMap[eventType].push({
      selector,
      handler,
      matcher,
      matcherParam,
    });
    return this;
  };
  Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
    let i;
    let listener;
    let listenerMap;
    let listenerList;
    let singleEventType;
    if (typeof selector === 'function') {
      useCapture = handler;
      handler = selector;
      selector = null;
    }
    if (useCapture === void 0) {
      this.off(eventType, selector, handler, true);
      this.off(eventType, selector, handler, false);
      return this;
    }
    listenerMap = this.listenerMap[useCapture ? 1 : 0];
    if (!eventType) {
      for (singleEventType in listenerMap) {
        if (listenerMap.hasOwnProperty(singleEventType)) {
          this.off(singleEventType, selector, handler);
        }
      }
      return this;
    }
    listenerList = listenerMap[eventType];
    if (!listenerList || !listenerList.length) {
      return this;
    }
    for (i = listenerList.length - 1; i >= 0; i--) {
      listener = listenerList[i];
      if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
        this._removedListeners.push(listener);
        listenerList.splice(i, 1);
      }
    }
    if (!listenerList.length) {
      delete listenerMap[eventType];
      if (this.rootElement) {
        this.rootElement.removeEventListener(eventType, this.handle, useCapture);
      }
    }
    return this;
  };
  Delegate.prototype.handle = function (event) {
    let i;
    let l;
    const type = event.type;
    let root;
    let phase;
    let listener;
    let returned;
    let listenerList = [];
    let target;
    const eventIgnore = 'ftLabsDelegateIgnore';
    if (event[eventIgnore] === true) {
      return;
    }
    target = event.target;
    if (target.nodeType === 3) {
      target = target.parentNode;
    }
    if (target.correspondingUseElement) {
      target = target.correspondingUseElement;
    }
    root = this.rootElement;
    phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);
    switch (phase) {
      case 1:
        listenerList = this.listenerMap[1][type];
        break;
      case 2:
        if (this.listenerMap[0] && this.listenerMap[0][type]) {
          listenerList = listenerList.concat(this.listenerMap[0][type]);
        }
        if (this.listenerMap[1] && this.listenerMap[1][type]) {
          listenerList = listenerList.concat(this.listenerMap[1][type]);
        }
        break;
      case 3:
        listenerList = this.listenerMap[0][type];
        break;
    }
    let toFire = [];
    l = listenerList.length;
    while (target && l) {
      for (i = 0; i < l; i++) {
        listener = listenerList[i];
        if (!listener) {
          break;
        }
        if (
          target.tagName &&
          ['button', 'input', 'select', 'textarea'].indexOf(target.tagName.toLowerCase()) > -1 &&
          target.hasAttribute('disabled')
        ) {
          toFire = [];
        } else if (listener.matcher.call(target, listener.matcherParam, target)) {
          toFire.push([event, target, listener]);
        }
      }
      if (target === root) {
        break;
      }
      l = listenerList.length;
      target = target.parentElement || target.parentNode;
      if (target instanceof HTMLDocument) {
        break;
      }
    }
    let ret;
    for (i = 0; i < toFire.length; i++) {
      if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
        continue;
      }
      returned = this.fire.apply(this, toFire[i]);
      if (returned === false) {
        toFire[i][0][eventIgnore] = true;
        toFire[i][0].preventDefault();
        ret = false;
        break;
      }
    }
    return ret;
  };
  Delegate.prototype.fire = function (event, target, listener) {
    return listener.handler.call(target, event, target);
  };
  const main_delegate = Delegate;
  function matchesTag(tagName, element) {
    return tagName.toLowerCase() === element.tagName.toLowerCase();
  }
  function matchesRoot(selector, element) {
    if (this.rootElement === window) {
      return element === document || element === document.documentElement || element === window;
    }
    return this.rootElement === element;
  }
  function matchesId(id, element) {
    return id === element.id;
  }
  Delegate.prototype.destroy = function () {
    this.off();
    this.root();
  };

  function triggerEvent(element, name, data = {}) {
    element.dispatchEvent(
      new CustomEvent(name, {
        bubbles: true,
        detail: data,
      }),
    );
  }
  function filterShopifyEvent(event, domElement, callback) {
    let executeCallback = false;
    if (event.type.includes('shopify:section')) {
      if (domElement.hasAttribute('section') && domElement.getAttribute('section') === event.detail.sectionId) {
        executeCallback = true;
      }
    } else if (event.type.includes('shopify:block') && event.target === domElement) {
      executeCallback = true;
    }
    if (executeCallback) callback(event);
  }
  // === 焦点陷阱逻辑 ===
  function trapFocus(container) {
    const focusableSelectors = [
      'a[href]',
      'button:not([disabled])',
      'input:not([disabled])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      '[tabindex]:not([tabindex="-1"])',
    ];
    const focusableEls = Array.from(container.querySelectorAll(focusableSelectors.join(',')));
    if (focusableEls.length === 0) return;

    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];

    function handleKey(e) {
      if (e.key !== 'Tab') return;

      if (e.shiftKey) {
        // Shift + Tab
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        // Tab
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    }

    container.__focusHandler = handleKey;
    document.addEventListener('keydown', handleKey);
    firstEl.focus();
  }

  function releaseFocus(container) {
    if (container.__focusHandler) {
      document.removeEventListener('keydown', container.__focusHandler);
      delete container.__focusHandler;
    }
  }

  var MediaFeatures = class {
    static prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }
    static supportsHover() {
      return window.matchMedia('(pointer: fine)').matches;
    }
  };
  var CustomAnimation = class {
    constructor(effect) {
      this._effect = effect;
      this._playState = 'idle';
      this._finished = Promise.resolve();
    }
    get finished() {
      return this._finished;
    }
    get animationEffects() {
      return this._effect instanceof CustomKeyframeEffect ? [this._effect] : this._effect.animationEffects;
    }
    cancel() {
      this.animationEffects.forEach((animationEffect) => animationEffect.cancel());
    }
    finish() {
      this.animationEffects.forEach((animationEffect) => animationEffect.finish());
    }
    play() {
      this._playState = 'running';
      this._effect.play();
      this._finished = this._effect.finished;
      this._finished.then(
        () => {
          this._playState = 'finished';
        },
        (rejection) => {
          this._playState = 'idle';
        },
      );
    }
  };
  var CustomKeyframeEffect = class {
    constructor(target, keyframes, options = {}) {
      if (!target) {
        return;
      }
      if ('Animation' in window) {
        this._animation = new Animation(new KeyframeEffect(target, keyframes, options));
      } else {
        options['fill'] = 'forwards';
        this._animation = target.animate(keyframes, options);
        this._animation.pause();
      }
      this._animation.addEventListener('finish', () => {
        target.style.opacity = keyframes.hasOwnProperty('opacity')
          ? keyframes['opacity'][keyframes['opacity'].length - 1]
          : null;
        target.style.visibility = keyframes.hasOwnProperty('visibility')
          ? keyframes['visibility'][keyframes['visibility'].length - 1]
          : null;
      });
    }
    get finished() {
      if (!this._animation) {
        return Promise.resolve();
      }
      return this._animation.finished
        ? this._animation.finished
        : new Promise((resolve) => (this._animation.onfinish = resolve));
    }
    play() {
      if (this._animation) {
        this._animation.startTime = null;
        this._animation.play();
      }
    }
    cancel() {
      if (this._animation) {
        this._animation.cancel();
      }
    }
    finish() {
      if (this._animation) {
        this._animation.finish();
      }
    }
  };
  var GroupEffect = class {
    constructor(childrenEffects) {
      this._childrenEffects = childrenEffects;
      this._finished = Promise.resolve();
    }
    get finished() {
      return this._finished;
    }
    get animationEffects() {
      return this._childrenEffects.flatMap((effect) => {
        return effect instanceof CustomKeyframeEffect ? effect : effect.animationEffects;
      });
    }
  };
  var ParallelEffect = class extends GroupEffect {
    play() {
      const promises = [];
      for (const effect of this._childrenEffects) {
        effect.play();
        promises.push(effect.finished);
      }
      this._finished = Promise.all(promises);
    }
  };

  var CustomHTMLElement = class extends HTMLElement {
    constructor() {
      super();
      this._hasSectionReloaded = false;
      if (Shopify.designMode) {
        this.rootDelegate.on('shopify:section:select', (event) => {
          const parentSection = this.closest('.shopify-section');
          if (event.target === parentSection && event.detail.load) {
            this._hasSectionReloaded = true;
          }
        });
      }
    }
    get rootDelegate() {
      return (this._rootDelegate = this._rootDelegate || new main_delegate(document.documentElement));
    }
    get delegate() {
      return (this._delegate = this._delegate || new main_delegate(this));
    }
    untilVisible(intersectionObserverOptions = { rootMargin: '30px 0px', threshold: 0 }) {
      const onBecameVisible = () => {
        this.classList.add('became-visible');
        this.style.opacity = '1';
      };
      return new Promise((resolve) => {
        if (window.IntersectionObserver) {
          this.intersectionObserver = new IntersectionObserver((event) => {
            if (event[0].isIntersecting) {
              this.intersectionObserver.disconnect();
              requestAnimationFrame(() => {
                resolve();
                onBecameVisible();
              });
            }
          }, intersectionObserverOptions);
          this.intersectionObserver.observe(this);
        } else {
          resolve();
          onBecameVisible();
        }
      });
    }
    disconnectedCallback() {
      this.delegate.destroy();
      this.rootDelegate.destroy();
      delete this._delegate;
      delete this._rootDelegate;
    }
  };

  // js/custom-element/section/blog/article-list.js
  var ArticleList = class extends CustomHTMLElement {
    async connectedCallback() {
      this.articleItems = Array.from(this.querySelectorAll('.article-layout-card'));
      if (this.staggerApparition) {
        await this.untilVisible({
          threshold: this.clientHeight > 0 ? Math.min(50 / this.clientHeight, 1) : 0,
        });
        const animation = new CustomAnimation(
          new ParallelEffect(
            this.articleItems.map((item, index) => {
              return new CustomKeyframeEffect(
                item,
                {
                  opacity: [0, 1],
                  transform: [
                    `translateY(${MediaFeatures.prefersReducedMotion() ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`,
                    'translateY(0)',
                  ],
                },
                {
                  duration: 600,
                  delay: MediaFeatures.prefersReducedMotion()
                    ? 0
                    : 100 * index - Math.min(3 * index * index, 100 * index),
                  easing: 'ease',
                },
              );
            }),
          ),
        );
        this._hasSectionReloaded ? animation.finish() : animation.play();
      }
    }
    get staggerApparition() {
      return this.hasAttribute('stagger-apparition');
    }
  };
  window.customElements.define('article-list', ArticleList);

  // js/custom-element/behavior/page-pagination.js
  var PagePagination = class extends CustomHTMLElement {
    connectedCallback() {
      if (this.hasAttribute('ajax')) {
        this.delegate.on('click', 'a', this._onLinkClicked.bind(this));
      }
    }
    _onLinkClicked(event, target) {
      event.preventDefault();
      const url = new URL(window.location.href);
      url.searchParams.set('page', target.getAttribute('data-page'));
      history.pushState(null, '', url.toString());
      document.dispatchEvent(
        new CustomEvent('blog:page-changed', {
          detail: { url: url.toString() },
        }),
      );
    }
  };
  window.customElements.define('page-pagination', PagePagination);

  class VideoIntersectionInsert extends HTMLElement {
    constructor() {
      super();
      this._observer = null;
      this._isPlaying = false;
      this._loaded = false;
      this._playedOnce = false;
    }

    connectedCallback() {
      const videoHtml = this.dataset.src;
      if (!videoHtml) return;
      this._observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const visibleHeight = entry.intersectionRect.height;
          if (this.hasAttribute('once') && this._playedOnce) return;
          if (visibleHeight >= 100 && !this._loaded) {
            const videoDiv = document.createElement('div');
            videoDiv.innerHTML = videoHtml;
            this._video = videoDiv.querySelector('video');
            this.querySelectorAll('img').forEach((b) => (b.style.visibility = 'hidden'));
            this.appendChild(this._video);
            this._video.addEventListener('ended', () => {
              if (this.hasAttribute('once')) {
                this._playedOnce = true;
                this._observer?.disconnect();
                this._video.pause();
              }
            });
            this._video.play().catch(() => {});
            this._loaded = true;
            this._isPlaying = true;
          }
          if (visibleHeight >= 100 && !this._isPlaying && !this._playedOnce) {
            this._video.play().catch(() => {});
            this._isPlaying = true;
          } else if (visibleHeight < 100 && this._isPlaying && !this.hasAttribute('once')) {
            this._video.pause();
            this._isPlaying = false;
          }
        },
        {
          root: null,
          threshold: Array.from({ length: 101 }, (_, i) => i / 100),
        },
      );

      this._observer.observe(this);
    }

    disconnectedCallback() {
      this._observer?.disconnect();
    }
  }

  if (!customElements.get('video-intersection-insert')) {
    customElements.define('video-intersection-insert', VideoIntersectionInsert);
  }

  const CompareStore = {
    _list: [],
    _collectionHandle: '',
    getList() {
      return this._list.map((item) => ({ ...item }));
    },
    setList(list) {
      this._list = Array.isArray(list) ? list.map((item) => ({ ...item })) : [];
      document.dispatchEvent(
        new CustomEvent('compare-action-update', {
          detail: { list: this.getList() },
        }),
      );
    },
    clear() {
      this.setList([]);
    },
    getCollectionHandle() {
      return this._collectionHandle;
    },
    setCollectionHandle(handle) {
      this._collectionHandle = handle || '';
    },
  };

  window.CompareStore = CompareStore;

  class ProductCompare extends HTMLElement {
    constructor() {
      super();
      this.maxCompareNum = 3;
      this.handleClick = this.handleClick.bind(this);
      this.updateStatus = this.updateStatus.bind(this);
    }
    get compareText() {
      return this.dataset.compareText;
    }
    get selectedText() {
      return this.dataset.selectedText;
    }
    get ofText() {
      return this.dataset.ofText;
    }
    connectedCallback() {
      this.init();
    }

    init() {
      this.render();
      this.updateStatus();
      this.querySelector('.card-compare').addEventListener('click', this.handleClick);
      document.addEventListener('compare-action-update', this.updateStatus);
      document.addEventListener('compare-update', this.updateStatus);
    }

    disconnectedCallback() {
      document.removeEventListener('compare-action-update', this.updateStatus);
    }

    /** 当前产品信息 */
    get productInfo() {
      return {
        id: this.dataset.id,
        title: this.dataset.title || '',
        image: this.dataset.image || '',
      };
    }

    /** 当前集合 handle */
    get currentCollectionHandle() {
      return this.dataset.collectionHandle || '';
    }

    /** 获取对比产品列表 */
    getCompareList() {
      return CompareStore.getList();
    }

    /** 保存对比产品列表 */
    setCompareList(list) {
      CompareStore.setList(list);
    }

    /** 更新按钮状态与文字 */
    updateStatus() {
      const cardCompare = this.querySelector('.card-compare');
      const list = this.getCompareList();
      const exists = list.some((item) => item.id == this.productInfo.id);

      // 按钮样式
      cardCompare?.classList.toggle('active', exists);

      // ✅ 按钮文字逻辑
      if (exists) {
        cardCompare.innerHTML = `
        <span>
          <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.70444 7.27329L1.21906 4.7897C1.08514 4.65587 0.903505 4.58069 0.714111 4.58069C0.524717 4.58069 0.34308 4.65587 0.209158 4.7897C0.0752365 4.92353 0 5.10503 0 5.29429C0 5.388 0.0184712 5.4808 0.0543586 5.56738C0.0902461 5.65395 0.142847 5.73262 0.209158 5.79888L3.20306 8.79065C3.4824 9.06978 3.93363 9.06978 4.21297 8.79065L11.7908 1.21819C11.9248 1.08437 12 0.902859 12 0.713601C12 0.524342 11.9248 0.342835 11.7908 0.209009C11.6569 0.0751829 11.4753 0 11.2859 0C11.0965 0 10.9149 0.0751829 10.7809 0.209009L3.70444 7.27329Z" fill="#133EE3"/>
          </svg>
        </span>
        ${list.length} ${this.ofText} ${this.maxCompareNum} ${this.selectedText}
      `;
      } else {
        cardCompare.innerHTML = `
        <span>
          <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.70444 7.27329L1.21906 4.7897C1.08514 4.65587 0.903505 4.58069 0.714111 4.58069C0.524717 4.58069 0.34308 4.65587 0.209158 4.7897C0.0752365 4.92353 0 5.10503 0 5.29429C0 5.388 0.0184712 5.4808 0.0543586 5.56738C0.0902461 5.65395 0.142847 5.73262 0.209158 5.79888L3.20306 8.79065C3.4824 9.06978 3.93363 9.06978 4.21297 8.79065L11.7908 1.21819C11.9248 1.08437 12 0.902859 12 0.713601C12 0.524342 11.9248 0.342835 11.7908 0.209009C11.6569 0.0751829 11.4753 0 11.2859 0C11.0965 0 10.9149 0.0751829 10.7809 0.209009L3.70444 7.27329Z" fill="#133EE3"/>
          </svg>
        </span>
        ${this.compareText}
      `;
      }
    }

    /** 点击逻辑 */
    handleClick(event) {
      event.stopPropagation();
      let list = this.getCompareList();
      const index = list.findIndex((item) => item.id == this.productInfo.id);

      if (index !== -1) {
        list.splice(index, 1);
      } else if (list.length < this.maxCompareNum) {
        list.push(this.productInfo);
      } else {
        alert('Comparison quantity exceeds limit');
        return;
      }

      this.setCompareList(list);
      this.updateStatus();
    }

    render() {
      if (!this.querySelector('.card-compare')) {
        this.innerHTML = `
        <button class="card-compare fz-18 fz-m-16" type="button" aria-label="Add to compare">
          <span>
            <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3.70444 7.27329L1.21906 4.7897C1.08514 4.65587 0.903505 4.58069 0.714111 4.58069C0.524717 4.58069 0.34308 4.65587 0.209158 4.7897C0.0752365 4.92353 0 5.10503 0 5.29429C0 5.388 0.0184712 5.4808 0.0543586 5.56738C0.0902461 5.65395 0.142847 5.73262 0.209158 5.79888L3.20306 8.79065C3.4824 9.06978 3.93363 9.06978 4.21297 8.79065L11.7908 1.21819C11.9248 1.08437 12 0.902859 12 0.713601C12 0.524342 11.9248 0.342835 11.7908 0.209009C11.6569 0.0751829 11.4753 0 11.2859 0C11.0965 0 10.9149 0.0751829 10.7809 0.209009L3.70444 7.27329Z" fill="#133EE3"/>
            </svg>
          </span>
          Compare
        </button>
      `;
      }
    }
  }

  customElements.define('product-compare', ProductCompare);

  class ProductCompareFooter extends HTMLElement {
    get currentCollectionHandle() {
      return this.dataset.collectionHandle || '';
    }

    connectedCallback() {
      this.ensureSameCollection();
      this.render();
      this.setTransition();
      document.addEventListener('compare-action-update', () => this.render());
    }
    get clearText() {
      return 'Clear';
    }
    get selectedText() {
      return 'Selected';
    }
    get compareText() {
      return 'Compare';
    }
    get uptoText() {
      return 'Selected Up To';
    }
    get modelsText() {
      return 'Models';
    }
    setTransition() {
      const footer = document.querySelector('footer');
      const compareFooter = this;
      if (!footer || !compareFooter) return;
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          if (entry.isIntersecting) {
            // footer 进入视口，隐藏浮动栏
            compareFooter.classList.remove('show');
          } else {
            // footer 离开视口，显示浮动栏
            compareFooter.classList.add('show');
          }
        },
        {
          root: null, // 视口
          threshold: 0, // footer 只要有一点进入视口就触发
        },
      );
      observer.observe(footer);
    }
    handleComapre() {
      document.dispatchEvent(new CustomEvent('compare-init'));
      document.documentElement.setAttribute('scroll-lock', '');
      document.querySelector('.compare-modal').classList.add('show');
    }
    getCompareList() {
      return CompareStore.getList();
    }

    /** 检查集合是否变化 */
    ensureSameCollection() {
      const last = CompareStore.getCollectionHandle();
      const current = this.currentCollectionHandle;

      if (last && last !== current) {
        CompareStore.clear();
        document.dispatchEvent(new CustomEvent('compare-update'));
      }

      if (current && last !== current) {
        CompareStore.setCollectionHandle(current);
      }
    }

    clearAll() {
      CompareStore.clear();
    }

    render() {
      const list = this.getCompareList();
      if (!list.length) {
        this.innerHTML = '';
        this.classList.remove('show');
        return;
      }
      this.innerHTML = `
        <div class="compare-footer-container">
          <div class="container">
            <div class="compare-footer">
              <div class="compare-list-container">
                <div class="compare-list">
                  ${list
                    .map(
                      (item) => `
                      <div class="compare-item" data-id="${item.id}">
                        <img src="${item.image}" alt="${item.title}" />
                      </div>
                    `,
                    )
                    .join('')}
                </div>
                <span class="fz-18 fz-m-16">${this.uptoText} ${list.length} ${this.modelsText}</span>
              </div>
              <div class="compare-actions">
                <div class="compare-clear fz-18 fz-m-16">
                  <span>${this.clearText}</span>
                  ${list.length} ${this.selectedText}
                </div>
                <button class="compare-go fz-18 fz-m-16 common-btn common-btn-large common-btn-blue">${this.compareText}</button>
              </div>
            </div>
          </div>
        </div>
      `;
      this.classList.add('show');
      // 对比按钮
      this.querySelector('.compare-go').addEventListener('click', this.handleComapre);
      // 清空按钮事件
      this.querySelector('.compare-clear')?.addEventListener('click', () => this.clearAll());
    }
  }

  customElements.define('product-compare-footer', ProductCompareFooter);

  // === Toggle Button ===
  class ToggleButton extends HTMLButtonElement {
    static get observedAttributes() {
      return ['aria-expanded'];
    }
    constructor() {
      super();
      this.addEventListener('click', this._onButtonClick.bind(this));
      this.rootDelegate = new main_delegate(document.documentElement);
    }
    _onButtonClick() {
      this.isExpanded = !this.isExpanded;
    }
    connectedCallback() {
      document.addEventListener('openable-element:close', (event) => {
        if (this.controlledElement === event.target) {
          this.isExpanded = false;
          this.closest('.shop-the-look__product-wrapper')?.classList.remove('top-index');
          event.stopPropagation();
        }
      });
      document.addEventListener('openable-element:open', (event) => {
        if (this.controlledElement === event.target) {
          this.isExpanded = true;
          this.closest('.shop-the-look__product-wrapper')?.classList.add('top-index');
          event.stopPropagation();
        }
      });
    }
    disconnectedCallback() {
      this.rootDelegate.destroy();
    }
    get isExpanded() {
      return this.getAttribute('aria-expanded') === 'true';
    }
    set isExpanded(value) {
      this.setAttribute('aria-expanded', value ? 'true' : 'false');
    }
    get controlledElement() {
      return document.getElementById(this.getAttribute('aria-controls'));
    }
    attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case 'aria-expanded':
          if (oldValue === 'false' && newValue === 'true') {
            this.controlledElement.open = true;
          } else if (oldValue === 'true' && newValue === 'false') {
            this.controlledElement.open = false;
          }
          break;
      }
    }
  }
  window.customElements.define('toggle-button', ToggleButton, {
    extends: 'button',
  });

  // === Openable Element ===
  class OpenableElement extends CustomHTMLElement {
    static get observedAttributes() {
      return ['open'];
    }
    constructor() {
      super();
      if (Shopify.designMode) {
        this.rootDelegate.on('shopify:section:select', (event) =>
          filterShopifyEvent(event, this, () => (this.open = true)),
        );
        this.rootDelegate.on('shopify:section:deselect', (event) =>
          filterShopifyEvent(event, this, () => (this.open = false)),
        );
      }
      if (this.hasAttribute('append-body')) {
        const existingNode = document.getElementById(this.id);
        this.removeAttribute('append-body');
        if (existingNode && existingNode !== this) {
          existingNode.replaceWith(this.cloneNode(true));
          this.remove();
        } else {
          document.body.appendChild(this);
        }
      }
    }
    connectedCallback() {
      this.delegate.on('click', '.openable__overlay', () => (this.open = false));
      this.delegate.on('click', '[data-action="close"]', (event) => {
        event.stopPropagation();
        this.open = false;
      });
    }
    get open() {
      return this.hasAttribute('open');
    }
    set open(value) {
      if (value) {
        this.setAttribute('open', '');
      } else {
        this.removeAttribute('open');
      }
    }
    attributeChangedCallback(name, oldValue, newValue) {
      switch (name) {
        case 'open':
          if (oldValue === null && newValue === '') {
            // 打开
            setTimeout(() => trapFocus(this), 100);
            triggerEvent(this, 'openable-element:open');
          } else if (newValue === null) {
            // 关闭
            releaseFocus(this);
            triggerEvent(this, 'openable-element:close');
          }
      }
    }
  }
  window.customElements.define('openable-element', OpenableElement);

  class ProductSticky extends HTMLElement {
    constructor() {
      super();
      this.stickyForm = null;
      this.observer = null;
      this.addButton = null;
      this.header = null;
      this.headerPolicy = null;
    }

    connectedCallback() {
      this.stickyForm = this.querySelector('.product-sticky-form');
      // 尽量使用特定的类名，避免 document.querySelector 选择范围过大
      this.addButton = document.querySelector('.buy-buttons-block') || document.querySelector('.product-information');
      this.header = document.querySelector('.header');
      this.headerPolicy = document.querySelector('.header-policy');

      if (!this.stickyForm || !this.addButton) return;

      // 核心逻辑修改：基于 entry.isIntersecting 判断
      this.observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];

          // 如果 addButton 不在视口中 (isIntersecting 为 false)
          if (!entry.isIntersecting) {
            this.stickyForm.classList.remove('hidden-sticky');
          } else {
            // 如果 addButton 在视口中，则隐藏
            this.stickyForm.classList.add('hidden-sticky');
          }
        },
        {
          root: null,
          threshold: 0, // 只要有一像素进入或离开视口就会触发
        },
      );

      this.observer.observe(this.addButton);
      window.addEventListener('resize', this.handleResize);

      const section = this.closest('.shopify-section');
      section?.addEventListener('variant:update', this.#onVariantUpdate);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      const section = this.closest('.shopify-section');
      section?.removeEventListener('variant:update', this.#onVariantUpdate);
    }

    #onVariantUpdate = (event) => {
      const variant = event.detail?.resource;
      if (!variant?.id) return;

      const stickyRight = this.querySelector('.product-sticky-right');
      if (stickyRight) {
        stickyRight.classList.toggle('is-soldout', variant.available === false);
      }

      const buyNow = this.querySelector('.sticky-buy-now');
      if (buyNow) {
        const cartPath = buyNow.getAttribute('href')?.split('/').slice(0, -1).join('/') || '/cart';
        buyNow.href = `${cartPath}/${variant.id}:1`;
        if (variant.available === false) {
          buyNow.setAttribute('aria-disabled', 'true');
        } else {
          buyNow.removeAttribute('aria-disabled');
        }
      }
    };
  }

  customElements.define('product-sticky', ProductSticky);

  class BackToTop extends HTMLElement {
    constructor() {
      super();
      this.scrollThreshold = 600;
      this.scrollIdleDelay = 1000;
      this.backTopBtn = null;
      this.backTopTimer = null;
      this.onScroll = this.handleScroll.bind(this);
      this.onClick = this.scrollToTop.bind(this);
    }

    connectedCallback() {
      this.render();
      this.backTopBtn = this.querySelector('.back-top');

      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.backTopBtn.addEventListener('click', this.onClick);
      this.updateVisibility();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.backTopBtn.removeEventListener('click', this.onClick);
      clearTimeout(this.backTopTimer);
    }

    getScrollTop() {
      return document.documentElement.scrollTop || document.body.scrollTop;
    }

    shouldShow() {
      return this.getScrollTop() > this.scrollThreshold;
    }

    updateVisibility() {
      this.backTopBtn.classList.toggle('show', this.shouldShow());
    }

    handleScroll() {
        this.updateVisibility();
    }

    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth', // 平滑滚动
      });
    }

    render() {
      this.innerHTML = `
        <span class="back-top" id="backtop">
          ${this.renderIcon()}
        </span>
      `;
    }

    renderIcon() {
      return `
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#333"><path d="M160-760v-80h640v80H160Zm280 640v-408L336-424l-56-56 200-200 200 200-56 56-104-104v408h-80Z"/></svg>
      `;
    }
  }

  customElements.define('back-to-top', BackToTop);

  class CountryAction extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.showModal.bind(this));
    }
    showModal() {
      document.querySelector('.country-select-wrapper').classList.add('open');
    }
  }

  customElements.define('country-action', CountryAction);

  const GlobalAudioContext = {
    activeElement: null,
  };

  const APILoader = {
    yt: { loading: false, callbacks: [] },
    vimeo: { loading: false, callbacks: [] },
    loadYouTube(cb) {
      if (window.YT && window.YT.Player) return cb();
      this.yt.callbacks.push(cb);
      if (!this.yt.loading) {
        this.yt.loading = true;
        const script = document.createElement('script');
        script.src = 'https://www.youtube.com/iframe_api';
        window.onYouTubeIframeAPIReady = () => {
          this.yt.callbacks.forEach((c) => c());
        };
        document.head.appendChild(script);
      }
    },
    loadVimeo(cb) {
      if (window.Vimeo && window.Vimeo.Player) return cb();
      this.vimeo.callbacks.push(cb);
      if (!this.vimeo.loading) {
        this.vimeo.loading = true;
        const script = document.createElement('script');
        script.src = 'https://player.vimeo.com/api/player.js';
        script.onload = () => {
          this.vimeo.callbacks.forEach((c) => c());
        };
        document.head.appendChild(script);
      }
    },
  };

  class VideoIntersection extends HTMLElement {
    constructor() {
      super();
      this._observer = null;
      this._isPlaying = false;
      this._loaded = false;
      this._ready = false;
      this._pendingPlay = false;

      this._provider = this.dataset.provider || 'html5';
      this._videoId = this.dataset.videoId;
      this._muted = this.dataset.muted === 'true';
      this._controls = this.dataset.controls === 'true';
      this._player = null;
      this._isModal = this.dataset.isModal === 'true';
      this._pausedOnLoad = this.dataset.pausedOnLoad === 'true';
    }

    connectedCallback() {
      if (!this._videoId && !this.dataset.src) return;

      this._observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          const isVisible = entry.isIntersecting;

          if (isVisible && !this._loaded) {
            this.loadMedia();
          }

          if (this._pausedOnLoad) {
            if (!isVisible && this._isPlaying) {
              this.pauseMedia();
            }
          } else {
            if (isVisible && this._loaded && !this._isPlaying) {
              if (this._muted || this._isModal) {
                this.playMedia();
              }
            } else if (!isVisible && this._isPlaying) {
              this.handleViewportExit();
            }
          }
        },
        {
          root: null,
          rootMargin: '200px',
          threshold: [0],
        },
      );

      this._observer.observe(this);
    }

    handleViewportExit() {
      this.pauseMedia();
      if (!this._muted) {
        this.muteMedia();
      }
    }

    loadMedia() {
      this.innerHTML = '';
      this._loaded = true;

      if (this._provider === 'youtube') {
        const container = document.createElement('div');
        container.className = 'w-full h-full';
        if (!this._controls && this._muted) container.style.pointerEvents = 'none';
        this.appendChild(container);
        APILoader.loadYouTube(() => this.initYouTube(container));
      } else if (this._provider === 'vimeo') {
        const container = document.createElement('div');
        container.className = 'w-full h-full';
        if (!this._controls && this._muted) container.style.pointerEvents = 'none';
        this.appendChild(container);
        APILoader.loadVimeo(() => this.initVimeo(container));
      } else {
        this.loadHTML5();
      }
    }

    loadHTML5() {
      if (this.dataset.src) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = this.dataset.src;
        this._player = tempDiv.querySelector('video');
        this.appendChild(this._player);
      } else {
        this._player = document.createElement('video');
        this._player.src = this._videoId;
        this._player.className = this.dataset.class || '';
        this._player.loop = true;
        this._player.playsInline = true;
        if (this._muted) this._player.muted = true;
        if (this._controls) {
          this._player.controls = true;
        }
        this.appendChild(this._player);
      }

      if (!this._controls) {
        this._player.removeAttribute('controls');
        if (this._muted) {
          this._player.style.pointerEvents = 'none';
        } else {
          this._player.style.cursor = 'pointer';
          this._player.addEventListener('click', () => {
            if (this._isPlaying) {
              this.pauseMedia();
            } else {
              this.playMedia();
            }
          });
        }
      }

      if (this._muted) {
        if (this._player.readyState >= 1) {
          this.playMedia();
        } else {
          this._player.addEventListener(
            'loadedmetadata',
            () => {
              this.playMedia();
            },
            { once: true },
          );
        }
      }

      this._player.addEventListener('play', () => {
        this._isPlaying = true;
      });
      this._player.addEventListener('pause', () => {
        this._isPlaying = false;
      });
    }

    initYouTube(container) {
      const autoplayFlag = this._muted && !this._pausedOnLoad ? 1 : 0;

      // 动态判断：有控制条就给完整原生体验，无控制条则极限精简
      const playerVars = {
        autoplay: autoplayFlag,
        controls: this._controls ? 1 : 0,
        mute: this._muted ? 1 : 0,
        loop: 1,
        playlist: this._videoId,
        playsinline: 1,
        rel: 0,
      };

      if (!this._controls) {
        playerVars.modestbranding = 1;
        playerVars.disablekb = 1;
        playerVars.iv_load_policy = 3;
      }

      this._player = new YT.Player(container, {
        videoId: this._videoId,
        width: '100%', // 强制满宽满高，修复 UI 控制栏被切除的 Bug
        height: '100%',
        playerVars: playerVars,
        events: {
          onReady: () => {
            this._ready = true;
            if (this._pendingPlay) {
              this._pendingPlay = false;
              this.playMedia();
            } else if (!this._pausedOnLoad && (this._muted || this._isModal)) {
              this.playMedia();
            }
          },
          onStateChange: (e) => {
            if (e.data === YT.PlayerState.PLAYING) {
              this._isPlaying = true;
            } else if (e.data === YT.PlayerState.PAUSED) {
              this._isPlaying = false;
            }
          },
        },
      });
    }

    initVimeo(container) {
      this._player = new Vimeo.Player(container, {
        id: this._videoId,
        width: '100%',
        height: '100%',
        autoplay: this._muted && !this._pausedOnLoad,
        controls: this._controls,
        muted: this._muted,
        loop: true,
        background: !this._controls && this._muted && !this._pausedOnLoad,
        // 动态判断：只有 controls: true 时才显示原生标题和头像信息
        title: this._controls,
        byline: this._controls,
        portrait: this._controls,
        dnt: true,
      });

      this._player.ready().then(() => {
        this._ready = true;
        if (this._pendingPlay) {
          this._pendingPlay = false;
          this.playMedia();
        } else if (!this._pausedOnLoad && (this._muted || this._isModal)) {
          this.playMedia();
        }
      });

      this._player.on('play', () => {
        this._isPlaying = true;
      });
      this._player.on('pause', () => {
        this._isPlaying = false;
      });
    }

    playMedia() {
      if ((this._provider === 'youtube' || this._provider === 'vimeo') && !this._ready) {
        if (!this._loaded) this.loadMedia();
        this._pendingPlay = true;
        return;
      }

      if (!this._muted) {
        if (GlobalAudioContext.activeElement && GlobalAudioContext.activeElement !== this) {
          GlobalAudioContext.activeElement.muteMedia();
        }
        GlobalAudioContext.activeElement = this;
      }

      if (this._provider === 'html5' && this._player) {
        const playPromise = this._player.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              this._isPlaying = true;
              if (!this._muted) this._player.muted = false;
            })
            .catch(() => {
              this._isPlaying = false;
            });
        }
      } else if (this._provider === 'youtube' && this._player?.playVideo) {
        this._player.playVideo();
        if (!this._muted) this._player.unMute();
        this._isPlaying = true;
      } else if (this._provider === 'vimeo' && this._player?.play) {
        this._player.play();
        if (!this._muted) this._player.setVolume(1);
        this._isPlaying = true;
      }
    }

    pauseMedia() {
      if (this._provider === 'html5' && this._player) {
        this._player.pause();
      } else if (this._provider === 'youtube' && this._player?.pauseVideo) {
        this._player.pauseVideo();
      } else if (this._provider === 'vimeo' && this._player?.pause) {
        this._player.pause();
      }
      this._isPlaying = false;
    }

    muteMedia() {
      if (this._provider === 'html5' && this._player) {
        this._player.muted = true;
      } else if (this._provider === 'youtube' && this._player?.mute) {
        this._player.mute();
      } else if (this._provider === 'vimeo' && this._player?.setVolume) {
        this._player.setVolume(0);
      }

      if (GlobalAudioContext.activeElement === this) {
        GlobalAudioContext.activeElement = null;
      }
    }

    resetMedia() {
      if (this._provider === 'html5' && this._player) {
        this._player.currentTime = 0;
      } else if (this._provider === 'youtube' && this._player?.seekTo) {
        this._player.seekTo(0, true);
      } else if (this._provider === 'vimeo' && this._player?.setCurrentTime) {
        this._player.setCurrentTime(0);
      }
    }

    disconnectedCallback() {
      this._observer?.disconnect();
    }
  }

  if (!customElements.get('video-intersection')) {
    customElements.define('video-intersection', VideoIntersection);
  }
  // 锚点平滑滚动
  function scrollToAnchorTarget(target, { ignoreHeaderOffset = false } = {}) {
    let targetTop = target.getBoundingClientRect().top + window.scrollY;

    if (!ignoreHeaderOffset) {
      const stickyHeader = document.querySelector('.header');
      const headerOffset = stickyHeader ? stickyHeader.offsetHeight : 0;
      targetTop -= headerOffset + 60;
    }

    window.scrollTo({
      top: Math.max(targetTop, 0),
      behavior: 'smooth',
    });
  }

  window.scrollToAnchorTarget = scrollToAnchorTarget;

  function initAnchorScrollLinks() {
    document.querySelectorAll('a[data-anchor-id]').forEach((link) => {
      if (link.dataset.anchorScrollBound === 'true') return;

      link.dataset.anchorScrollBound = 'true';
      link.addEventListener('click', (e) => {
        const targetId = link.dataset.anchorId;
        if (!targetId) return;

        e.preventDefault();

        const target = document.querySelector(`[data-anchor-target-id='${targetId}']`);
        if (!target) return;

        scrollToAnchorTarget(target, {
          ignoreHeaderOffset: link.dataset.anchorIgnoreHeaderOffset === 'true',
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initAnchorScrollLinks);
  document.addEventListener('shopify:section:load', initAnchorScrollLinks);

  function removeQbkPopupListenerFromAddButtons() {
    document.querySelectorAll('button[name="add"]').forEach((button) => {
      if (button.getAttribute('qbk-popup-listener') === 'true') {
        button.removeAttribute('qbk-popup-listener');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', removeQbkPopupListenerFromAddButtons);
  document.addEventListener('shopify:section:load', removeQbkPopupListenerFromAddButtons);
})();
